import { useCurrentTenant } from "@qpr/client-library";
import { useAuth } from "@qpr/client-library/dist/esm";
import * as conf from "qpr-base/configuration";
import React, { ReactNode, ReactNodeArray, useEffect, useState } from "react";
import initializeLanguages from "./../../i18n";
import api, { ApiResult } from "./../apicaller/api-caller";
import { ApiEndpoint } from "./../apicaller/api-consts";
import { UserContext } from "./UserContext";

export default ({ children }: { children: ReactNode | ReactNodeArray }) => {
  const tenantSymbol = useCurrentTenant().symbol;
  const [user, setUser] = useState({
    fullname: "",
    email: "",
    username: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const { auth } = useAuth();
  useEffect(() => {
    const init = async () => {
      const userdata: ApiResult = await api.asyncCallApi(
        `${ApiEndpoint.sessionstatus}/${tenantSymbol}`,
        {
          method: "GET",
        }
      );
      let profile: ApiResult = await api.asyncCallApi(
        `${ApiEndpoint.profiles}/${userdata.data?.profileId}`,
        {
          method: "GET",
        }
      );
      if (userdata.ok) setUser({ ...userdata.data, profile: profile.data });

      if (userdata.ok && auth?.isAuthenticated) {
        let config;
        try {
          config = await api.asyncCallApi(`${ApiEndpoint.config}`, {
            method: "GET",
          });
          config = config?.data;
        } catch (e) {}
        conf.setDefaults("languages", config?.languages || ["en", "ar"]);
        conf.setViewSettings(config?.views);

        initializeLanguages();
      }
      setIsLoading(false);
    };
    init();
  }, [tenantSymbol]);
  return isLoading ? (
    <> </>
  ) : (
    <UserContext.Provider value={user}>{children}</UserContext.Provider>
  );
};
